module.exports = __webpack_public_path__ + "logo-mcce--2eab5ae9.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/parceiros/logo-mcce.png
// module id = 231
// module chunks = 0